import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-[#2a2d30] mt-8 py-6 text-[12px] text-gray-500 dark:text-gray-400">
      <div className="max-w-3xl mx-auto px-3 space-y-2">
        <div className="flex flex-wrap gap-x-3 gap-y-1">
          <Link to="/rewards" className="hover:text-gray-800 dark:hover:text-gray-200">
            rewards
          </Link>
          <Link to="/search" className="hover:text-gray-800 dark:hover:text-gray-200">
            search
          </Link>
          <a href="#faq" className="hover:text-gray-800 dark:hover:text-gray-200">
            faq
          </a>
          <a href="#guide" className="hover:text-gray-800 dark:hover:text-gray-200">
            guide
          </a>
        </div>
        <div className="flex flex-wrap gap-x-3 gap-y-1">
          <a
            href="https://nostr.com"
            target="_blank"
            rel="noreferrer"
            className="hover:text-gray-800 dark:hover:text-gray-200"
          >
            Powered by Nostr
          </a>
          <a
            href="https://github.com/stashernews/stasher-news"
            target="_blank"
            rel="noreferrer"
            className="hover:text-gray-800 dark:hover:text-gray-200"
          >
            source
          </a>
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noreferrer"
            className="hover:text-gray-800 dark:hover:text-gray-200"
          >
            Vibed with Shakespeare
          </a>
        </div>
      </div>
    </footer>
  );
}
